import { useState } from "react";
import type { FormEvent } from "react";
import useFormSubmit from "@/hooks/useFormSubmit";

export default function NewsletterForm() {
  const { status, message, submit } = useFormSubmit();
  const [count, setCount] = useState(0);
  const maxLength = 120;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const email = String(new FormData(form).get("email") ?? "").trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return;
    }
    submit(form, "website_alt", "订阅成功，翻车速递会发送到你的邮箱。");
  };

  return (
    <form
      id="newsletter-form-1"
      data-readdy-form
      action="https://readdy.ai/api/form/dahg5vrp14a1h3mr6llg"
      onSubmit={handleSubmit}
      className="w-full"
    >
      <div className="flex flex-col sm:flex-row gap-2.5">
        <div className="relative flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
            <i className="ri-mail-line text-base"></i>
          </span>
          <input
            type="email"
            name="email"
            required
            maxLength={maxLength}
            onChange={(event) => setCount(event.target.value.length)}
            placeholder="留下邮箱，第一时间收到事件更新"
            className="w-full h-11 pl-10 pr-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          />
        </div>
        <button
          type="submit"
          disabled={status === "submitting"}
          className="h-11 px-5 rounded-md bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors disabled:opacity-60 cursor-pointer flex items-center justify-center gap-1.5"
        >
          <i className="ri-notification-3-line"></i>
          {status === "submitting" ? "提交中..." : "订阅更新"}
        </button>
      </div>
      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="hp-alt-field"
      />
      <div className="mt-2 flex items-center justify-between gap-3 flex-wrap">
        <p className="text-xs text-foreground-500">每周一封，只发已核实的事件，不灌水。</p>
        <p className="text-[11px] text-foreground-400">{count}/{maxLength}</p>
      </div>
      {message && (
        <p
          className={`mt-2 text-xs ${status === "error" ? "text-primary-700" : "text-secondary-700"}`}
          role="status"
        >
          {message}
        </p>
      )}
    </form>
  );
}